<template>
    <div>
        <div class="content-box" style="margin-top: -20px;">
            <p class="text-color-gray mb10">输入或粘贴{{tipText}}，每行一个</p>
            <div class="batch-content">
                <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="batchCon"
                    :rows="10"
                    resize="none"
                    style="min-height: 200px;"
                >
                </el-input>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideBatchModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitBatchModal" :loading="batchLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "BatchChooseModal",
        props:{
            cbs:{
                type:Object,
            },
            typeText:String,
        },
        data(){
            return {
                batchCon:'',
                batchLoading:false,
            }
        },
        computed:{
            tipText(){
                let tipText = '内容';
                let typeText = this.typeText||'';
                if(typeText.includes('产品')){
                    tipText = '名称/ID/包名';
                }else if(typeText.includes('账户')||typeText.includes('计划')){
                    tipText = '名称/ID';
                }
                return tipText;
            },
        },
        methods:{
            hideBatchModal(){
                this.$emit('close');
            },
            hideLoading(){
                this.batchLoading = false;
            },
            submitBatchModal(){
                this.batchLoading = true;
                this.cbs.onSubmit(this.batchCon.split(/\n/).map(item=>item.trim()).filter(item=>!!item), this.hideLoading);
            },
        },
    }
</script>

<style scoped>

</style>
